/* unplugin-vue-components disabled */import script from "./Stat.vue?vue&type=script&lang=ts&setup=true"
export * from "./Stat.vue?vue&type=script&lang=ts&setup=true"

import "./Stat.vue?vue&type=style&index=0&id=7987afe5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7987afe5"]])

export default __exports__